import { client } from '../../../hooks/Client'
import { useFirestoreGeneral } from '../../../firebase/useFirestore'
import { deriveConnectionStatus } from '../../../helpers/impactInBeeld/deriveConnectionStatus'
import ApiKeyBlock from '../config/ApiKeyBlock.jsx'

/**
 * @typedef {object} Integration
 * @property {string} id - Stable identifier
 * @property {string} title - Integration name
 * @property {string} description - What the connection feeds
 * @property {boolean} viaApi - Loopt via de generieke transactie-API (fase 3)
 */

/** @type {Array<Integration>} */
const integrations = [
    {
        id: 'kassa',
        title: 'Kassa',
        description: 'Voedt het live scherm bij de kassa, de kassabon en de impactfeed.',
        viaApi: true,
    },
    {
        id: 'webshop',
        title: 'Webshop',
        description: 'Voedt de webshop-widget met impact per product.',
        viaApi: true,
    },
    {
        id: 'boekhouding',
        title: 'Boekhouding',
        description: 'Voedt straks de impactregels op je offertes en facturen.',
        viaApi: false,
    },
]

/**
 * Integraties tab (fase 3): de generieke transactie-API met sleutelbeheer.
 * Kassa en webshop koppelen via dezelfde API; status 'Gekoppeld' verschijnt
 * pas zodra de eerste echte transactie is binnengekomen. Boekhouding is nog
 * in ontwikkeling. See docs/features/impact-in-beeld-fase3.md.
 */
const IntegrationsTab = () => {

    const liveStats = useFirestoreGeneral('ImpactLiveStats', 'CompagnyID', client)
    const connection = deriveConnectionStatus((liveStats || [])[0])

    return (
        <div className='impact-in-beeld-tab'>
            <h2>Integraties</h2>
            <p className='impact-in-beeld-tab-intro'>
                Verbind externe systemen om je kanalen automatisch te voeden.
            </p>
            <ApiKeyBlock />
            <div className='impact-channel-list'>
                {integrations.map((integration) => (
                    <div key={integration.id} className='impact-channel-card'>
                        <div className='impact-channel-card-header'>
                            <h3>{integration.title}</h3>
                            {integration.viaApi ? (
                                connection === 'connected' ? (
                                    <span className='impact-channel-status impact-channel-status--live'>Gekoppeld</span>
                                ) : (
                                    <span className='impact-channel-status impact-channel-status--off'>Nog niet gekoppeld</span>
                                )
                            ) : (
                                <span className='impact-channel-status impact-channel-status--off'>Nog niet gekoppeld</span>
                            )}
                        </div>
                        <p className='impact-channel-card-description'>{integration.description}</p>
                        {integration.viaApi ? (
                            <p className='impact-in-beeld-tab-intro'>
                                Koppelt via de transactie-API hierboven; de status springt op
                                <strong> 'Gekoppeld'</strong> zodra de eerste afrekening binnenkomt.
                            </p>
                        ) : (
                            <p className='impact-in-beeld-tab-pending'>Deze koppeling is in ontwikkeling.</p>
                        )}
                    </div>
                ))}
            </div>
        </div>
    )
}

export default IntegrationsTab
